export default "__VITE_ASSET__Wb_5TfKq__"